// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccessHubsController from "./access_hubs_controller"
application.register("access-hubs", AccessHubsController)

import BrowserTimeController from "./browser_time_controller"
application.register("browser-time", BrowserTimeController)

import ClipperNumberLengthController from "./clipper_number_length_controller"
application.register("clipper-number-length", ClipperNumberLengthController)

import Components__SelectSwitchFieldController from "./components/select_switch_field_controller"
application.register("components--select-switch-field", Components__SelectSwitchFieldController)

import Components__ToggleSubmitController from "./components/toggle_submit_controller"
application.register("components--toggle-submit", Components__ToggleSubmitController)

import Datagrids__FilterController from "./datagrids/filter_controller"
application.register("datagrids--filter", Datagrids__FilterController)

import Datagrids__TableController from "./datagrids/table_controller"
application.register("datagrids--table", Datagrids__TableController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DialogOpenerController from "./dialog_opener_controller"
application.register("dialog-opener", DialogOpenerController)

import Docs__SubnavController from "./docs/subnav_controller"
application.register("docs--subnav", Docs__SubnavController)

import ExpensesController from "./expenses_controller"
application.register("expenses", ExpensesController)

import FlatpickrDateController from "./flatpickr_date_controller"
application.register("flatpickr-date", FlatpickrDateController)

import G7AccessHubs__BatchEditController from "./g7_access_hubs/batch_edit_controller"
application.register("g7-access-hubs--batch-edit", G7AccessHubs__BatchEditController)

import G7AccessHubsController from "./g7_access_hubs_controller"
application.register("g7-access-hubs", G7AccessHubsController)

import G7CommandCodesFormController from "./g7_command_codes_form_controller"
application.register("g7-command-codes-form", G7CommandCodesFormController)

import G7Spaces__AmountToggleController from "./g7_spaces/amount_toggle_controller"
application.register("g7-spaces--amount-toggle", G7Spaces__AmountToggleController)

import G7Spaces__BatchEditController from "./g7_spaces/batch_edit_controller"
application.register("g7-spaces--batch-edit", G7Spaces__BatchEditController)

import GoogleMapsController from "./google_maps_controller"
application.register("google-maps", GoogleMapsController)

import HistoryController from "./history_controller"
application.register("history", HistoryController)

import Home__CardsSearchController from "./home/cards_search_controller"
application.register("home--cards-search", Home__CardsSearchController)

import Home__LocationSpaceSearchController from "./home/location_space_search_controller"
application.register("home--location-space-search", Home__LocationSpaceSearchController)

import Home__PeopleSearchController from "./home/people_search_controller"
application.register("home--people-search", Home__PeopleSearchController)

import LaborsController from "./labors_controller"
application.register("labors", LaborsController)

import Locations__LockersController from "./locations/lockers_controller"
application.register("locations--lockers", Locations__LockersController)

import LogBatchErrorsController from "./log_batch_errors_controller"
application.register("log-batch-errors", LogBatchErrorsController)

import Maps__ListController from "./maps/list_controller"
application.register("maps--list", Maps__ListController)

import Maps__MapController from "./maps/map_controller"
application.register("maps--map", Maps__MapController)

import Maps__SearchStateController from "./maps/search_state_controller"
application.register("maps--search-state", Maps__SearchStateController)

import Maps__TransitCardsMapController from "./maps/transit_cards_map_controller"
application.register("maps--transit-cards-map", Maps__TransitCardsMapController)

import MaterialsController from "./materials_controller"
application.register("materials", MaterialsController)

import Owners__Locations__LockerCodesController from "./owners/locations/locker_codes_controller"
application.register("owners--locations--locker-codes", Owners__Locations__LockerCodesController)

import Owners__Locations__LockerSearchController from "./owners/locations/locker_search_controller"
application.register("owners--locations--locker-search", Owners__Locations__LockerSearchController)

import Owners__Locations__UsageReportController from "./owners/locations/usage_report_controller"
application.register("owners--locations--usage-report", Owners__Locations__UsageReportController)

import PartsController from "./parts_controller"
application.register("parts", PartsController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ProblemReports__LookupPersonResultsController from "./problem_reports/lookup_person_results_controller"
application.register("problem-reports--lookup-person-results", ProblemReports__LookupPersonResultsController)

import ProblemReports__SetCategoriesController from "./problem_reports/set_categories_controller"
application.register("problem-reports--set-categories", ProblemReports__SetCategoriesController)

import ProblemReports__StorageUnitSelectionController from "./problem_reports/storage_unit_selection_controller"
application.register("problem-reports--storage-unit-selection", ProblemReports__StorageUnitSelectionController)

import ServiceVisits__FormController from "./service_visits/form_controller"
application.register("service-visits--form", ServiceVisits__FormController)

import ServiceVisits__PerformedServicesFormController from "./service_visits/performed_services_form_controller"
application.register("service-visits--performed-services-form", ServiceVisits__PerformedServicesFormController)

import ServiceVisits__WorkOrdersFormController from "./service_visits/work_orders_form_controller"
application.register("service-visits--work-orders-form", ServiceVisits__WorkOrdersFormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TripsController from "./trips_controller"
application.register("trips", TripsController)

import TroubleTickets__BatchEditController from "./trouble_tickets/batch_edit_controller"
application.register("trouble-tickets--batch-edit", TroubleTickets__BatchEditController)

import TroubleTickets__BatchEditModalController from "./trouble_tickets/batch_edit_modal_controller"
application.register("trouble-tickets--batch-edit-modal", TroubleTickets__BatchEditModalController)
